// Right-sizes an avatar URL for the box that renders it. Gravatar (and Auth0's Gravatar-backed
// default) serves whatever pixel size the `s=` query param asks for, so callers pass the rendered
// box size instead of the raw s=480. Google identity pictures (lh*.googleusercontent.com) encode
// the size as an `=s96-c` path suffix instead of an `s=` query param, so rewrite that suffix's
// s-token too (keeping modifiers like `-c`); anything else is returned untouched.
//
// A `d=` fallback only stays sized when Gravatar serves it itself: for an account with no Gravatar
// image, s.gravatar.com 302-redirects to a URL-valued fallback with the size stripped and any query
// on the fallback dropped (#4974), so the fallback image — e.g. Auth0's 120×120 initials tile —
// always arrives at full resolution and no URL tweak can right-size it. Gravatar's symbolic
// defaults (mp, identicon, …) are generated at the requested size with no redirect, so a URL-valued
// fallback on a gravatar.com host is replaced with `mp`, the neutral person silhouette.
export function sizedAvatar(url: string, px: number): string {
  try {
    const u = new URL(url)
    if (u.searchParams.has('s')) {
      u.searchParams.set('s', String(px))
      const isGravatar = u.hostname === 'gravatar.com' || u.hostname.endsWith('.gravatar.com')
      if (isGravatar && /^https?:/i.test(u.searchParams.get('d') ?? '')) {
        u.searchParams.set('d', 'mp')
      }
      return u.toString()
    }
    const sizeSuffix = u.pathname.match(/=s\d+((?:-[a-z0-9]+)*)$/)
    if (!sizeSuffix) return url
    u.pathname = u.pathname.slice(0, u.pathname.length - sizeSuffix[0].length) + `=s${px}${sizeSuffix[1]}`
    return u.toString()
  } catch {
    return url
  }
}
